export default __webpack_public_path__ + "static/media/music.c710b2ad.mp3";